module.exports = __webpack_public_path__ + "static/media/journey.23489d02.jpg";